module.exports = __webpack_public_path__ + "static/media/arj.2fe921ee.svg";